import { HttpTypes } from '@/types';
import { BaseLocation } from '@/types/http/location/common';
import { ILocationData } from '@/types/location';

import { AxiosInstance } from 'axios';

class Locations {
  private client: AxiosInstance;
  private routePath = '/sites';
  private routeLocation = '/sites/location';

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async list(query: HttpTypes.FindParams): Promise<HttpTypes.IResponse<BaseLocation[]>> {
    const result = await this.client.get(`/sites/location`, {
      params: query,
    });
    return result.data;
  }

  async detail(id: string): Promise<HttpTypes.IResponse<HttpTypes.AdminLocation>> {
    const response = await this.client.get(`/sites/location/${id}`);
    return response.data;
  }

  async update(data: ILocationData): Promise<HttpTypes.IResponse<ILocationData>> {
    const response = await this.client.put(`/sites/location/${data.location_id}`, data);
    return response.data;
  }

  async active(
    id: string,
    payload: { is_active: boolean }
  ): Promise<HttpTypes.IResponse<BaseLocation[]>> {
    const res = await this.client.put(`${this.routeLocation}/active/${id}`, payload);
    return res.data;
  }

  async priority(
    id: string,
    payload: { is_default: boolean }
  ): Promise<HttpTypes.IResponse<BaseLocation[]>> {
    const res = await this.client.put(`${this.routeLocation}/priority/${id}`, payload);
    return res.data;
  }

  async pickup(
    id: string,
    payload: { is_pickup_in_store: boolean }
  ): Promise<HttpTypes.IResponse<BaseLocation[]>> {
    const res = await this.client.put(`${this.routeLocation}/pickup-active/${id}`, payload);
    return res.data;
  }
}

export default Locations;
